import { DialogOverlay } from '@reach/dialog'
import { useDispatch, useSelector } from 'react-redux'

import { actions as miniCartActions } from '@/reducers/miniCart'

import Content from './Content'

const MiniCartDialog = () => {
  const isShowing = useSelector(state => state.miniCart.isShowing)
  const isVirtualStore = useSelector(state => state.currentRegion.virtualStore)
  const dispatch = useDispatch()

  const onDismiss = () => {
    dispatch(miniCartActions.setIsShowing(false))
  }

  const classNames = [
    'mini-cart-reach-dialog-overlay'
  ]

  return (
    <DialogOverlay
      className={
        isVirtualStore
          ? [...classNames, 'virtual-store'].join(' ') : [...classNames]
      }
      isOpen={isShowing}
      onDismiss={onDismiss}
    >
      <Content {...{ isShowing, onDismiss }} />
    </DialogOverlay>
  )
}

export default MiniCartDialog
